import { api } from "./client";
import type { MaterialAudience } from "./portalMaterials";
import type { SenderValueSource } from "@/lib/formSchema";

// Special forms (WS-3) — staff client for the resolved special-form
// definition read. Mirrors
//   GET /collection/special-forms/{templateId}/definition?dealId=&partyId=
// which 404s when the template is not a special form. Computed fields and
// calibration.* tokens come back UNRESOLVED (prefilledValue null) — the
// client computes them (SenderDetailsSection's existing logic). Prefilled
// values are plain strings: numbers invariant-culture, dates yyyy-MM-dd.

export interface SpecialFormFieldDefinition {
  name: string;
  label: string;
  type: string;
  required: boolean;
  valueSource: SenderValueSource;
  sourceToken: string | null;
  prefilledValue: string | null;
  isComputed: boolean;
}

export interface SpecialFormDefinition {
  templateId: string;
  name: string;
  version: number;
  audience: MaterialAudience;
  bodyTemplateMarkdown: string;
  fields: SpecialFormFieldDefinition[];
}

export const collectionSpecialFormsApi = {
  getDefinition: (
    templateId: string,
    opts: { dealId?: string | null; partyId?: string | null } = {},
  ) =>
    api.get<SpecialFormDefinition>(
      `/collection/special-forms/${templateId}/definition`,
      {
        dealId: opts.dealId ?? undefined,
        partyId: opts.partyId ?? undefined,
      },
    ),
};
